import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderLine } from 'src/app/theBookableServices/models/order.model';
import { OrderDetailsDialogComponent } from '../order-details-dialog.component';
import { environment } from 'src/environments/environment';
import { StripeResponseService } from 'src/app/services/stripe-response.service';
import { SitesService } from 'src/app/admin/1.tv/sites/sites.service';

@Component({
  selector: 'app-admir-order-details-dialog',
  templateUrl: './admir-order-details-dialog.component.html',
  styleUrls: ['./admir-order-details-dialog.component.scss']
})
export class AdmirOrderDetailsDialogComponent extends OrderDetailsDialogComponent implements OnInit {
  public orderTotals = 0;
  public paidOrderTotals = 0;
  public unPaidOrderTotals = 0;
  currency: string;
  public order: any;
  public deliveryAddress: any;

  constructor(
    stripeResponseService: StripeResponseService,
    sitesService: SitesService,
    public dialogRef: MatDialogRef<AdmirOrderDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public booking: any) {
    super(stripeResponseService, sitesService, dialogRef, booking);
  }

  ngOnInit(): void {

    this.deliveryAddress = this.booking.homeDelivery;
    this.order = this.booking.orders[0];
    this.sitesService.findSiteByCompanyIdSiteId(this.companyId, this.siteId)
      .subscribe((sites) => {

        this.currency = (sites[0].cashCurrency !== undefined) ? sites[0].cashCurrency : 'GBP';

        if (this.currency === 'EUR') {
          this.symbol = '';
          this.euro = '€';
        } else {
          this.symbol = 'symbol';
          this.euro = '';
        }
      });


    this.order.orderLines.forEach((orderLine: OrderLine) => {
      this.orderTotals = (this.orderTotals + Number(orderLine.cost * orderLine.quantity));

      if (this.order.paymentStatus === true) {
        this.paidOrderTotals = (this.paidOrderTotals + Number(orderLine.cost * orderLine.quantity));

      }
      if (this.order.paymentStatus === false) {
        this.unPaidOrderTotals = (this.unPaidOrderTotals + Number(orderLine.cost * orderLine.quantity));

      }

    });

    console.log("this.order" , this.order)
  }

}
